import React from 'react'
import styles from './styles.module.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Item from './Item'
import hotel1 from './hotel1.jpg';
import hotel2 from './hotel2.jpg';
import hotel3 from './hotel2.jpg';

const Explore = () => {
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 3,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 504, min: 0 },
            items: 2,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

    return (
        <div>
            <div className={styles.header}>
                <h4>Explore Location Name</h4>
                <p>This area has a lot of quiet, relaxing places to offer</p>
            </div>
            <Carousel
                swipeable={true}
                draggable={false}
                showDots={false}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                autoPlay={true}
                autoPlaySpeed={3000}
                keyBoardControl={true}
                transitionDuration={1000}
                containerClass="carousel-container"
                removeArrowOnDeviceType={["tablet", "mobile"]}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
            >

               <Item name={"Kandima Maldives"} image={hotel1} stars="&#9733; &#9733; &#9733; &#9734; &#9734;" reviewAvg={"4.5"} />
               <Item name={"Crown Beach Hotel Maldives"} image={hotel2} stars="&#9733; &#9733; &#9733; &#9734; &#9734;" reviewAvg={"4.5"} />
               <Item name={"Royal Island Resort & Spa"} image={hotel3} stars="&#9733; &#9733; &#9733; &#9733; &#9733;" reviewAvg={"5"} />
               <Item name={"Kandima Maldives"} image={hotel1} stars="&#9733; &#9734; &#9734; &#9734; &#9734;" reviewAvg={"2"} />

            </Carousel>
        </div>
    )
}

export default Explore
